export default __webpack_public_path__ + "static/media/reason_compare.5183bc9a.svg";